import { render, staticRenderFns } from "./PracticeTable.vue?vue&type=template&id=037f9362"
import script from "./PracticeTable.vue?vue&type=script&lang=ts"
export * from "./PracticeTable.vue?vue&type=script&lang=ts"
import style0 from "./PracticeTable.vue?vue&type=style&index=0&id=037f9362&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports